import clsx from "clsx";
type Props = {
  text?: string;
  title?: string;
  id?: string;
  children?: any;
  icon?: any;
  type?: string;
  className?: string;
  iconSvg?: string;
  textclass?: string;
  onClick?: (e: any) => void;
};

export function Button({
  onClick,
  id,
  title,
  textclass,
  children,
  text,
  icon,
  type,
  className,
  iconSvg,
}: Props) {
  return (
    <>
      <button
        onClick={onClick}
        id={id}
        data-title={title}
        className={`ui-button ${type} ${className}`}
      >
        <div
          className={`d-flex font-family-roboto  flex-gap-4 align-items-center size12 ${textclass}`}
        >
          {icon && <i className={`${icon} mr-16`}></i>}
          {children}
          {text}
        </div>
      </button>
    </>
  );
}

Button.defaultProps = {
  className: "text-capitalize px-4 py-2 ",
  text: "",
  title: "",
  id: "",
  children: "",
  icon: "",
  type: "",
  textclass: "",
};
